{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Attributi Personalizzati",
    "HEADER_BTN_TXT": "Aggiungi Attributo Personalizzato",
    "LOADING": "Caricamento attributi personalizzati",
    "DESCRIPTION": "Un attributo personalizzato tiene traccia di informazioni aggiuntive sui tuoi contatti o sulle conversazioni — ad esempio il piano di abbonamento o la data del primo acquisto. Puoi aggiungere diversi tipi di attributi personalizzati, come testo, elenchi o numeri, per raccogliere le informazioni specifiche di cui hai bisogno.",
    "LEARN_MORE": "Scopri di più sugli attributi personalizzati",
    "COUNT": "{n} attributo | {n} attributi",
    "SEARCH_PLACEHOLDER": "Cerca attributi...",
    "NO_RESULTS": "Nessun attributo trovato corrispondente alla tua ricerca",
    "ATTRIBUTE_MODELS": {
      "CONVERSATION": "Conversazione",
      "CONTACT": "Contatto",
      "COMPANY": "Azienda"
    },
    "ATTRIBUTE_TYPES": {
      "TEXT": "Testo",
      "NUMBER": "Numero",
      "LINK": "Link",
      "DATE": "Data",
      "LIST": "Elenco",
      "CHECKBOX": "Checkbox"
    },
    "ADD": {
      "TITLE": "Aggiungi Attributo Personalizzato",
      "SUBMIT": "Crea",
      "CANCEL_BUTTON_TEXT": "Annulla",
      "FORM": {
        "NAME": {
          "LABEL": "Nome Visualizzato",
          "PLACEHOLDER": "Inserisci il nome da mostrare per l’attributo personalizzato",
          "ERROR": "Nome richiesto"
        },
        "DESC": {
          "LABEL": "Descrizione",
          "PLACEHOLDER": "Inserisci una descrizione dell'attributo personalizzato",
          "ERROR": "Descrizione richiesta"
        },
        "MODEL": {
          "LABEL": "Si applica a",
          "PLACEHOLDER": "Selezionane uno",
          "ERROR": "Modello richiesto"
        },
        "TYPE": {
          "LABEL": "Tipo",
          "PLACEHOLDER": "Seleziona un tipo di attributo",
          "ERROR": "Tipo richiesto",
          "LIST": {
            "LABEL": "Valori dell’elenco",
            "PLACEHOLDER": "Inserisci un valore da aggiungere all'elenco e premi il tasto invio",
            "ERROR": "Deve avere almeno un valore"
          }
        },
        "KEY": {
          "LABEL": "Chiave",
          "PLACEHOLDER": "Inserisci la chiave dell'attributo personalizzato",
          "ERROR": "Chiave richiesta",
          "IN_VALID": "Chiave non valida"
        },
        "REGEX_PATTERN": {
          "LABEL": "Espressione regolare",
          "PLACEHOLDER": "Inserisci un'espressione regolare per validare gli attributi personalizzati. (Opzionale)"
        },
        "REGEX_CUE": {
          "LABEL": "Suggerimento espressione regolare",
          "PLACEHOLDER": "Inserisci un suggerimento per l'espressione regolare. (Opzionale)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Abilita convalida espressione regolare"
        },
        "BADGES": {
          "PRE_CHAT": "Pre-chat",
          "RESOLUTION": "Risoluzione"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Attributo personalizzato aggiunto con successo!",
        "ERROR_MESSAGE": "Impossibile creare un Attributo Personalizzato. Riprova più tardi."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Elimina",
      "API": {
        "SUCCESS_MESSAGE": "Attributo Personalizzato eliminato con successo.",
        "ERROR_MESSAGE": "Impossibile eliminare l'attributo personalizzato. Riprova."
      },
      "CONFIRM": {
        "TITLE": "Sei sicuro di voler eliminare - {attributeName}",
        "PLACE_HOLDER": "Digita {attributeName} per confermare",
        "MESSAGE": "L'eliminazione rimuoverà l'attributo personalizzato",
        "YES": "Elimina ",
        "NO": "Annulla"
      }
    },
    "EDIT": {
      "TITLE": "Modifica Attributo Personalizzato",
      "UPDATE_BUTTON_TEXT": "Aggiorna",
      "TYPE": {
        "LIST": {
          "LABEL": "Valori dell’elenco",
          "PLACEHOLDER": "Inserisci i valori da aggiungere all'elenco e premi il tasto invio"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Attributo Personalizzato aggiornato correttamente",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'aggiornamento dell'attributo personalizzato, riprova"
      }
    },
    "TABS": {
      "HEADER": "Attributi Personalizzati",
      "CONVERSATION": "Conversazione",
      "CONTACT": "Contatto",
      "COMPANY": "Azienda"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nome",
        "DESCRIPTION": "Descrizione",
        "TYPE": "Tipo",
        "KEY": "Chiave"
      },
      "BUTTONS": {
        "EDIT": "Modifica",
        "DELETE": "Elimina"
      },
      "EMPTY_RESULT": {
        "404": "Non ci sono attributi personalizzati creati",
        "NOT_FOUND": "Non ci sono attributi personalizzati configurati"
      },
      "REGEX_PATTERN": {
        "LABEL": "Espressione regolare",
        "PLACEHOLDER": "Inserisci un'espressione regolare per validare gli attributi personalizzati. (Opzionale)"
      },
      "REGEX_CUE": {
        "LABEL": "Suggerimento espressione regolare",
        "PLACEHOLDER": "Inserisci un suggerimento per l'espressione regolare. (Opzionale)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Abilita convalida espressione regolare"
      }
    },
    "BADGES": {
      "PRE_CHAT": "Pre-chat",
      "RESOLUTION": "Risoluzione"
    }
  }
}
